<template>
  <router-link
    v-if="allowed"
    :to="to"
    :exact="exact"
    class="inline-block border-b-2 px-2 py-3 text-neutral-500 transition-colors duration-150 ease-out-quart hover:text-primary-500 md:px-4 lg:px-7"
    active-class="active"
  >
    {{ typeof label === 'function' ? label() : t(label) }}
  </router-link>
</template>

<script lang="ts" setup>
import { isPermissionAllowed } from '@infuse/ui/utils';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const router = useRouter();

interface Props {
  to: { name: string } | string;
  exact?: boolean;
  name: string;
  label: string | (() => string);
}

const props = withDefaults(defineProps<Props>(), {
  exact: true
});

const allowed = computed(() => {
  const route = router
    .getRoutes()
    .find((r) => (typeof props.to === 'string' ? r.path === props.to : r.name === props.to.name));

  return route ? isPermissionAllowed(route.meta) : true;
});

const { t } = useI18n();
</script>

<style lang="css" scoped>
/* Workaround for tailwind on active router links */
.active {
  @apply border-primary-500 text-primary-500 !important;
}
</style>
